// In src/utils/cryptoUtils.js

import CryptoJS from 'crypto-js';

// --- MIRROR THE BACKEND'S LOGIC ---

// 1. Get the base secret from the .env file
const SECRET = process.env.REACT_APP_CRYPTO_SECRET;

if (!SECRET) {
  throw new Error("Critical: REACT_APP_CRYPTO_SECRET is not defined in your .env file!");
}

// 2. Create the KEY by hashing the secret, exactly like the backend does
const KEY = CryptoJS.SHA256(SECRET);

// 3. The IV is no longer needed here because it's part of the encrypted text

// ------------------------------------

/**
 * Decrypts a string that was encrypted by the backend.
 * The format is "iv:ciphertext".
 */
export async function decryptAES(combinedText) {
  if (!combinedText || typeof combinedText !== 'string' || !combinedText.includes(':')) {
    // Return null if the text is invalid or doesn't have the IV
    return null;
  }

  try {
    // 1. Split the IV from the actual encrypted message
    const parts = combinedText.split(':');
    const ivHex = parts.shift(); // The IV is the first part
    const encryptedText = parts.join(':'); // The rest is the message

    // 2. Parse the IV from its hexadecimal string format
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    // 3. Decrypt using the correct KEY and the extracted IV
    const bytes = CryptoJS.AES.decrypt(encryptedText, KEY, { iv: iv });
    
    const originalText = bytes.toString(CryptoJS.enc.Utf8);

    // If decryption results in an empty string, it failed
    return originalText ? originalText : null;

  } catch (err) {
    console.error("❌ Decryption failed:", err);
    return null;
  }
}